

















import VueOptions from '@utils/VueOptions'
import AudienceAvailabilityForm from '@superComponents/AudienceAvailability/AudienceAvailabilityForm'

settings =
  name: 'AudienceAvailabilityBulkEdit'

  resources:
    audience_availabilities:
      resourceName: 'audience_availability'
      slug: 'audience_availabilities'
      fetch: false

  vue:
    components: {
      AudienceAvailabilityForm,
    }

    data: ->
      audienceAvailabilityBulkEditModal:
        show: true

      form:
        data: {}
        fields: {}
        errors: {}

    computed:
      member: -> @$store.member
      supplierId: -> @member.supplier.id

      audienceAvailabilityIds: ->
        return [] if @$route.query.audienceAvailabilities is 'all'
        @$route.query.audienceAvailabilities

      allAudienceAvailabilities: ->
        @$route.query.audienceAvailabilities is 'all'

    methods:
      hiCloseModal: ->
        @$router.back()

      hiUpdate: ->
        payload =
          audience_availability_ids: @audienceAvailabilityIds
          all_audience_availabilities: @allAudienceAvailabilities
          atts: @form.data
        @triggerResource 'audience_availabilities', 'bulk_edit', payload
      onAudienceAvailabilitiesBulkEdit: ->
        @hiCloseModal()

export default VueOptions.vue settings
